import { AuthApi } from '@reposit/api-client';
import axios from 'axios';
import { Dispatch } from 'redux';
import { appConfig } from '../../appConfig';
import { setToken } from './auth.actions';

// Sends tenancy's session cookie, with the header tenancy requires before it reads it.
export const internalSessionRequestOptions = {
  withCredentials: true,
  headers: { 'x-reposit-internal-session': '1' },
};

// Gets a new token from the session cookie and keeps it in redux. Resolves undefined when tenancy says there's no
// session to restore. Rejects when tenancy can't say, with a 5xx or no answer at all, so the session is kept.
export async function restoreAccessToken(dispatch: Dispatch): Promise<string | undefined> {
  try {
    const authApi = new AuthApi({}, appConfig.api.basePath, axios);
    const { data } = await authApi.restoreInternalSession(internalSessionRequestOptions);
    if (data.accessToken) {
      dispatch(setToken(data.accessToken));
    }
    return data.accessToken;
  } catch (error) {
    const status: number | undefined = error && error.response ? error.response.status : undefined;
    const couldNotCheckSession = status === undefined || status >= 500;
    if (couldNotCheckSession) {
      throw error;
    }
    return undefined;
  }
}

// The token lives in redux only, so a reload or a new tab gets a new one from the session cookie.
export async function restoreInternalSession(dispatch: Dispatch): Promise<void> {
  try {
    // Builds before the session cookie kept the token in localStorage.
    window.localStorage.removeItem('persist:root');
  } catch {
    // The browser blocks site data, so there's no session cookie to restore from either: the admin lands on the login page.
    return;
  }
  // When tenancy can't check the session, the admin lands on the login page with the cookie kept, and a reload
  // once tenancy is back restores it.
  await restoreAccessToken(dispatch).catch(() => undefined);
}
